import React, { Component } from 'react';
import { connect } from 'react-redux';
import Highlighter from "react-highlight-words";

import { errorHandler, getContent, getErrorMessage } from '../../../util/responseUtil';
import ActionType from '../../../redux/reducer/globalActionType';
import BreadCrumbs from '../../../components/BreadCrumbs/BreadCrumbs';
import RemarkMenu from '../../../components/MasterData/RemarkMenu';
import IconActionEditBlue from '../../../assets/icons/IconActionEditBlue';
import IconInformationBlue from '../../../assets/icons/IconInformationBlue';
import ButtonBorderNexcareDefault from '../../../components/Button/ButtonBorderNexcareDefault';
import ButtonNexcareDefault from '../../../components/Button/ButtonNexcareDefault';
import TableNexcare from '../../../components/Table/TableNexcare';
import API_REMARK from '../../../api/apiRemark';
import Alert from '../../../components/Alert/Alert';
import Mandatory from '../../../components/Common/Mandatory';
import MandatoryAlert from '../../../components/Common/MandatoryAlert';
import { CheckPermissionComponent } from '../../../util/permission';
import {
    MASTER_DATA_REMARK_UPDATE,
    MASTER_DATA_REMARK_VIEW
} from '../../../constants/menuPermissionConstant';

class AutomaticMessage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
            },
            columns: [
                {
                    title: "Remark",
                    dataIndex: "remark",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/4",
                    render: (data) => `${data}`,
                },
                {
                    title: "Deskripsi Remark",
                    dataIndex: "description",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    render: (data) => {
                        let text = data;
                        let parts = text.split(/(%NamaCS|%NomorTiket)/);
                        return (
                            <div>
                                {parts.map((part, index) => {
                                    if (part === '%NamaCS' || part === '%NomorTiket') {
                                        return (
                                            <span key={index} className="bg-nexcaregray2 text-nexcaredefault rounded p-1">
                                                {part}
                                            </span>
                                        );
                                    }
                                    return part;
                                })}
                            </div>
                        )
                    },
                },
                {
                    title: "Aksi",
                    headerAlign: "justify-start",
                    bodyAlign: "text-left",
                    width: "w-1/12",
                    render: (data) => (
                        <div className="flex items-center space-x-3">
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_UPDATE]} userPermission={this.props.userDetail.permissions}>
                                <div id="btnedit" className="w-6 h-6 flex justify-center items-center cursor-pointer" onClick={() => this.setState({ showEditModal: true, automaticMessageDataSelectedEdit: data, automaticMessageTitle: data.remark, automaticMessageDescription: data.description })}>
                                    <IconActionEditBlue />
                                </div>
                            </CheckPermissionComponent>
                        </div>
                    ),
                },
            ],
            listAutomaticMessage: [],
            automaticMessageTitle: '',
            automaticMessageDescription: '',
            automaticMessageDataSelectedEdit: {},
            automaticMessageDataSelectedDelete: {},
            showWarningAutomaticMessageTitle: false,
            showWarningAutomaticMessageDescription: false,
            showPopupInfo: false,
            showEditModal: false,
            showConfirmEditAlert: false,
            showSuccessEditAlert: false,
            showErrorAlertResponse: false,
            errorMessage: ''
        }
    }

    handleSelectedPage = currentPage => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    current: currentPage,
                },
            },
            () => {
                this.getInitiateAutomaticMessage();
                this.getListAutomaticMessage(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    };

    handleSelectedPageSize = currentPageSize => {
        this.setState(
            {
                pagination: {
                    ...this.state.pagination,
                    pageSize: currentPageSize,
                    current: 1,
                },
            },
            () => {
                this.getInitiateAutomaticMessage();
                this.getListAutomaticMessage(this.state.pagination.current, this.state.pagination.pageSize);
            }
        );
    }

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleButtonCsName = () => {
        if (!this.state.automaticMessageDescription.includes('%NamaCS')) {
            this.setState({
                automaticMessageDescription: this.state.automaticMessageDescription + '%NamaCS'
            })
        }
    }

    handleButtonTicketNumber = () => {
        if (!this.state.automaticMessageDescription.includes('%NomorTiket')) {
            this.setState({
                automaticMessageDescription: this.state.automaticMessageDescription + '%NomorTiket'
            })
        }
    }

    getInitiateAutomaticMessage = () => {
        API_REMARK.getInitiateAutomaticMessage(this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        pagination: { ...this.state.pagination, total: getContent(res).count_data }
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    getListAutomaticMessage = (current, pageSize) => {
        API_REMARK.getListAutomaticMessage(current, pageSize, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        listAutomaticMessage: getContent(res)
                    })
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history))
    }

    handleCancelButton = () => {
        this.setState({
            showAddModal: false,
            showEditModal: false,
            showWarningAutomaticMessageTitle: false,
            showWarningAutomaticMessageDescription: false,
            automaticMessageTitle: '',
            automaticMessageDescription: ''
        });
    }

    handleConfirmEditAutomaticMessage = () => {
        if (!this.state.automaticMessageTitle || !this.state.automaticMessageDescription) {
            if (!this.state.automaticMessageTitle) this.setState({ showWarningAutomaticMessageTitle: true });
            if (!this.state.automaticMessageDescription) this.setState({ showWarningAutomaticMessageDescription: true });
            return;
        }
        this.setState({ showConfirmEditAlert: true });
    }

    handleEditAutomaticMessage = () => {
        const automaticMessageId = this.state.automaticMessageDataSelectedEdit.id;
        const data = {
            remark: this.state.automaticMessageTitle,
            description: this.state.automaticMessageDescription,
            category: 'default-message',
            category_id: this.state.automaticMessageDataSelectedEdit.category_id,
            updated_at: this.state.automaticMessageDataSelectedEdit.updated_at
        }

        API_REMARK.putDataRemark(automaticMessageId, data, this.props.token)
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        showEditModal: false,
                        showConfirmEditAlert: false,
                        showSuccessEditAlert: true,
                        automaticMessageTitle: '',
                        automaticMessageDescription: ''
                    });
                }
            }).catch(errorHandler(this.props.handleLogout, this.props.history, err => {
                this.setState({
                    showConfirmEditAlert: false,
                    errorMessage: getErrorMessage(err),
                    showErrorAlertResponse: true
                });
            }))
    }

    handleSuccessEditAutomaticMessage = () => {
        this.setState({
            showSuccessEditAlert: false,
            pagination: {
                ...this.state.pagination,
                current: 1,
                pageSize: 10,
            },
        }, () => {
            this.getInitiateAutomaticMessage();
            this.getListAutomaticMessage(this.state.pagination.current, this.state.pagination.pageSize);
        })
    }

    componentDidMount() {
        this._isMounted = true;

        this.getInitiateAutomaticMessage();
        this.getListAutomaticMessage(this.state.pagination.current, this.state.pagination.pageSize);
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                <div className="h-full pb-5">
                    {/* Breadcrumbs */}
                    <BreadCrumbs
                        parentMenu="Master Data"
                        serviceMenu="Remark"
                        title="Pesan Otomatis"
                    />

                    {/* White Container */}
                    <div className="h-content">
                        {/* Content */}
                        <div className="calculate-layout-blank bg-white border border-gray-300 rounded-lg px-6 py-10 space-y-10 overflow-auto">
                            {/* Menu */}
                            <RemarkMenu />

                            <div className="space-y-4">
                                <div className="flex justify-between items-center flex-row-reverse h-12">
                                    {/*  Automatic Message Information */}
                                    <div className="flex justify-center items-center relative">
                                        <div id="btninfo" className="cursor-pointer" onMouseEnter={() => this.setState({ showPopupInfo: true })} onMouseLeave={() => this.setState({ showPopupInfo: false })}>
                                            <IconInformationBlue />
                                        </div>
                                        <div className={this.state.showPopupInfo ? "absolute w-max top-0 right-10 z-10 rounded-lg shadow-box-button p-5 text-sm bg-nexcarewhite2" : "hidden"}>
                                            <div className="italic">
                                                <p className="font-bold">Note :</p>
                                                <p>Pesan Otomatis digunakan untuk pengiriman pesan ke user mobile saat tiket diassign, eskalasi, dan ditutup.</p>
                                                <p>Tombol %NamaCS digunakan untuk menambahkan variable Nama CS pada pesan.</p>
                                                <p>Tombol %NomorTiket digunakan untuk menambahkan variable Nomor Tiket pada pesan.</p>
                                                <p>Contoh:</p>
                                                <p>Hallo saya CS %NamaCS [Felix Febriano], tiket keluhan anda dengan nomor %NomorTiket [CS230700012] sedang kami tinjau,</p>
                                                <p>mohon deskripsikan keluhan anda</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Table Automatic Message */}
                                <div>
                                    <TableNexcare
                                        column={this.state.columns}
                                        dataTable={this.state.listAutomaticMessage}
                                        pagination={this.state.pagination}
                                        onPage={this.handleSelectedPage}
                                        onPageSize={this.handleSelectedPageSize}
                                        halfBodyHeight
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Edit Automatic Message Modal */}
                    <div className={this.state.showEditModal ? "block" : "hidden"}>
                        <div className="flex justify-center items-center fixed inset-0 z-50 outline-none focus:outline-none">
                            <div className="border-0 rounded-lg shadow-lg bg-white outline-none focus:outline-none p-10 space-y-4 w-1/2">
                                <p className="text-nexcareblack1 text-center text-3xl font-medium">Ubah Pesan Otomatis</p>
                                <div className="space-y-1">
                                    <p className="text-nexcareblack2 text-sm font-medium">Remark <Mandatory /></p>
                                    <input type="text" className="form-control" value={this.state.automaticMessageTitle} disabled />
                                </div>
                                <div className="space-y-1">
                                    <p className="text-nexcareblack2 text-sm font-medium">Deskripsi Remark <Mandatory /></p>
                                    <div className="flex items-center space-x-3">
                                        <button type="button" className="bg-transparent rounded-md border border-nexcaredefault text-nexcaredefault focus:outline-none font-medium px-3 py-1" onClick={this.handleButtonCsName}>%NamaCS</button>
                                        <button type="button" className="bg-transparent rounded-md border border-nexcaredefault text-nexcaredefault focus:outline-none font-medium px-3 py-1" onClick={this.handleButtonTicketNumber}>%NomorTiket</button>
                                    </div>
                                    <p className="text-sm text-nexcaregray1">Pilih tombol %NamaCS atau %NomorTiket untuk menambah variabel pada pesan</p>
                                    <div className="relative h-48">
                                        <textarea
                                            id="tmlautomaticmessageedit"
                                            className="form-control resize-none h-full bg-transparent text-transparent border-transparent caret-black absolute top-0 left-0 z-10"
                                            placeholder="Tulis Deskripsi Remark"
                                            name="automaticMessageDescription"
                                            onChange={e => {
                                                this.handleChange(e);
                                                this.setState({ showWarningAutomaticMessageDescription: false });
                                            }}
                                            minLength=""
                                            maxLength="300"
                                            autoComplete="off"
                                            value={this.state.automaticMessageDescription}
                                        />
                                        <div className="form-control h-full absolute top-0 left-0 overflow-auto">
                                            <Highlighter
                                                highlightClassName="bg-nexcaregray2 text-nexcaredefault rounded py-1"
                                                searchWords={["%NamaCS", "%NomorTiket"]}
                                                textToHighlight={this.state.automaticMessageDescription}
                                                autoEscape
                                                caseSensitive
                                            />
                                        </div>
                                    </div>
                                    {this.state.showWarningAutomaticMessageDescription && <MandatoryAlert text="Deskripsi Remark tidak boleh kosong!" />}
                                </div>
                                <div className="flex justify-center items-center space-x-5">
                                    <ButtonBorderNexcareDefault id="btncancel" onClick={this.handleCancelButton}>
                                        Batal
                                    </ButtonBorderNexcareDefault>
                                    <ButtonNexcareDefault id="btneditautomaticmessage" onClick={this.handleConfirmEditAutomaticMessage}>
                                        Simpan
                                    </ButtonNexcareDefault>
                                </div>
                            </div>
                        </div>
                        <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                    </div>

                    {/* Alert */}
                    <Alert show={this.state.showConfirmEditAlert} button title="Simpan Pesan Otomatis" desc="Apakah Anda yakin ingin mengubah data?" close={() => this.setState({ showConfirmEditAlert: false })} submit={this.handleEditAutomaticMessage} />
                    <Alert show={this.state.showSuccessEditAlert} icon="success" title="Berhasil" desc="Data berhasil diubah" close={this.handleSuccessEditAutomaticMessage} ok />
                    <Alert show={this.state.showErrorAlertResponse} icon="warning" title="Oops, Gagal" desc={this.state.errorMessage} close={() => this.setState({ showErrorAlertResponse: false })} ok />
                </div>
            </CheckPermissionComponent>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.authentication.token,
        userDetail: state.authentication.userDetail
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        handleLogout: () => dispatch({ type: ActionType.IS_LOGOUT })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AutomaticMessage);